import { QElement } from "./QElement";

export class QDragPanelDraggerBoxElement extends QElement {
  constructor() {
    super();
    this.fParentPanel = null;
  }

  InitPanelDraggerBox(parentPanel) {
    this.fParentPanel = parentPanel;
    this.SetIsSelectable(false);
    this.SetIsControl(false);
  }

  DeltaFromDragOrigin() {
    return this.fParentPanel.DeltaFromDragOrigin();
  }

  DoRenderElement(drawBuffer) {
    //this.DoDrawPad(drawBuffer);

    var ctx = drawBuffer.getContext("2d");
    ctx.save();

    ctx.fillStyle = "#CAE5FF";
    ctx.strokeStyle = "#7EBFFF";
    ctx.linewidth = 2;

    ctx.strokeRect(this.fHorzOffset, this.fVertOffset, this.fWidth, this.fHeight);

    ctx.globalAlpha = 0.5;
    ctx.fillRect(this.fHorzOffset, this.fVertOffset, this.fWidth, this.fHeight);

    ctx.restore();
  }
}
